export default "__VITE_ASSET__071984d9__"